<template>
    <transition name="modal-fade">
        <div class="modal-overlay" @click="$emit('close-modal')">
            <div class="modal-content" @click.stop >

                 
                 <div class="invisible_button" @click="$emit('close-modal')"></div>
            </div>
            
        </div>
    </transition>

</template>

<script>
    export default {
         
      
    }
</script>

<style scoped>
    .modal-overlay {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        justify-content: center;
        background-color: #00000088;
    }

    .modal-content {
        text-align: center;
        background-image:url('../../assets/images/get_started.png');
        background-position:center;
        background-repeat:no-repeat;
        background-size:contain;
        height:300px;
        width: 400px;
        max-width:90%;
        margin-top: 10%;
        overflow: hidden;
        background-color:transparent !important;
        border: none;
    }

    @media screen and (max-width: 539px) {
        .modal-content {
            max-width: 80%;
            text-align: center;
            margin-left: 10%;
            display: flex;
        }

        
    }

    .invisible_button{ width: 220px; height: 40px; margin:200px auto 0px auto; cursor:pointer;}


    .check {
        width: 150px;
    }

    h6 {
        font-weight: 500;
        font-size: 28px;
        margin: 20px 0;
    }

    p {
        /* font-weight: 500; */
        font-size: 16px;
        margin: 20px 0;
    }

    button {
        background-color: #ac003e;
        width: 150px;
        height: 40px;
        color: white;
        font-size: 14px;
        border-radius: 16px;
        margin-top: 50px;
    }

    .modal-fade-enter,
    .modal-fade-leave-to {
        opacity: 0;
    }

    .modal-fade-enter-active,
    .modal-fade-leave-active {
        transition: opacity 0.5s ease;
    }
</style>